// POST Event Triggers
export const POST_EVENTTRIGGERS_REQUEST = "POST_EVENTTRIGGERS_REQUEST";
export const POST_EVENTTRIGGERS_SUCCESS = "POST_EVENTTRIGGERS_SUCCESS";
export const POST_EVENTTRIGERRS_FAILURE = "POST_EVENTTRIGERRS_FAILURE";

// PUT Event Trigger
export const PUT_EVENTTRIGGERS_REQUEST = "PUT_EVENTTRIGGERS_REQUEST";
export const PUT_EVENTTRIGGERS_SUCCESS = "PUT_EVENTTRIGGERS_SUCCESS";
export const PUT_EVENTTRIGGERS_FAILURE = "PUT_EVENTTRIGGERS_FAILURE";

// DELETE Event Trigger
export const DELETE_EVENTTRIGGERS_REQUEST = "DELETE_EVENTTRIGGERS_REQUEST";
export const DELETE_EVENTTRIGGERS_SUCCESS = "DELETE_EVENTTRIGGERS_SUCCESS";
export const DELETE_EVENTTRIGGERS_FAILURE = "DELETE_EVENTTRIGGERS_FAILURE";